import React from "react";

import {
  View,
  Dimensions,
  StyleSheet,
  Text,
  SafeAreaView,
  TextInput,
  ScrollView,
  Platform,
} from "react-native";

import cardStyles from "../home/gated-product/styles";
import ManaButton from "../common/ManaButton";
import AppMessages from "../../../config/AppMessages";
import { isWeb, navigate, openURL } from "../../../helpers/utils";
import appStyles from "../../appStyles";
import Header from '../common/header/index';

export default class InviteFriendsPage extends React.Component {
  constructor(props) {
    super(props);
    this.controller = props.controller;

    this.state = {
      currentUser: this.controller.state?.currentUser,
    };
  }

  goBack = () => {
    this.controller.goBack();
  };

  updateFriendEmail = (key, email) => {
    this.setState((state) => ({ ...state, [key]: email }));
  };

  sendEmail = () => {
    const { email1, email2, email3, currentUser } = this.state;

    const emails = [email1, email2, email3].filter(Boolean).join("%0A"); // newline
    const emailUrl = `${AppMessages.GuidesEmail}?subject=Referrals from ${currentUser}&body=${emails}`;
    openURL(emailUrl);

    setTimeout(() => {
      navigate(this.controller, "rn:more", {});
    }, 500);
  };

  render() {
    const { email1, email2, email3 } = this.state;
    return (
      <View style={appStyles.container}>
        <Header title="Invite Friends" goBack={this.goBack} hideAvatar />

        <ScrollView style={{ marginTop: 20, paddingHorizontal: 10 }}>
          <Text style={styles.text}>
            We’re so glad you’re enjoying Mana, and thank you for paying it
            forward!
          </Text>

          <Text style={styles.text}>
            Please share some friends email addresses so we can extend our
            special discount. When they sign up, we’ll reward you each with a
            $10 credit toward your subscriptions!
          </Text>

          <View
            style={{
              marginTop: 30,
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <TextInput
              placeholderTextColor="rgba(45, 49, 66, 0.3)"
              name={"friend1"}
              placeholder="myfriend@example.com"
              onChangeText={(text) => this.updateFriendEmail("email1", text)}
              value={email1 || ""}
              style={styles.input}
            />

            <TextInput
              placeholderTextColor="rgba(45, 49, 66, 0.3)"
              name={"friend1"}
              placeholder="myfriend@example.com"
              onChangeText={(text) => this.updateFriendEmail("email2", text)}
              value={email2 || ""}
              style={styles.input}
            />

            <TextInput
              placeholderTextColor="rgba(45, 49, 66, 0.3)"
              name={"friend1"}
              placeholder="myfriend@example.com"
              onChangeText={(text) => this.updateFriendEmail("email3", text)}
              value={email3 || ""}
              style={styles.input}
            />
          </View>

          <View style={[cardStyles.buttons, { marginTop: isWeb ? 200 : 75 }]}>
            <ManaButton
              disabled={!email1 && !email2 && !email3}
              onPress={this.sendEmail}
              style={[cardStyles.button, { height: 56, borderRadius: 16 }]}
              styleText={cardStyles.buttonText}
              text="Refer Friends"
            />
          </View>
        </ScrollView>
      </View>
    );
  }
}

const styles = StyleSheet.create({
  header: {
    width: "100%",
  },
  headerIcon: {
    width: "100%",
    height: 150,
    ...appStyles.maxWidth,
  },
  leftContainer: {
    position: "absolute",
    left: 10,
    top: isWeb ? 0 : 20,
    width: 48,
    height: "100%",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    zIndex: 10,
  },
  input: {
    fontFamily:  Platform.select({ default: "Montserrat", android: "Montserrat-SemiBold" }),
    fontWeight: "600",
    fontSize: 16,
    lineHeight: 20,
    letterSpacing: 1,
    color: "rgba(45, 49, 66, 0.6)",
    borderBottomWidth: 1,
    borderBottomColor: "rgba(45, 49, 66, 0.3)",
    padding: 10,
    width: "80%",
    marginTop: 20,
  },
  text: {
    fontFamily:  Platform.select({ default: "Montserrat", android: "Montserrat-SemiBold" }),
    fontWeight: "600",
    fontSize: 14,
    lineHeight: 17,
    letterSpacing: 0.175,
    color: "#222",
    textAlign: "center",
    marginBottom: 20,
  },
});
